import React from 'react';

const UnidadeNegocioContext = React.createContext();

export default UnidadeNegocioContext;
